export interface MDA {
  id: string
  name: string
  acronym: string
  description: string
  logoUrl: string
  serviceCount: number
}
export const mdas: MDA[] = [
  {
    id: '1',
    name: 'Ministry of Finance',
    acronym: 'MOF',
    description:
      'Responsible for financial management and economic planning of the state.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 8,
  },
  {
    id: '2',
    name: 'Ministry of Education',
    acronym: 'MOE',
    description:
      'Oversees educational institutions and implements educational policies.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 6,
  },
  {
    id: '3',
    name: 'Ministry of Health',
    acronym: 'MOH',
    description:
      'Responsible for healthcare services and public health initiatives.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 5,
  },
  {
    id: '4',
    name: 'Ministry of Lands and Surveys',
    acronym: 'MLS',
    description: 'Manages land administration and geographical surveys.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 7,
  },
  {
    id: '5',
    name: 'Ministry of Transport',
    acronym: 'MOT',
    description: 'Oversees transportation infrastructure and services.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 4,
  },
  {
    id: '6',
    name: 'Edo State Internal Revenue Service',
    acronym: 'EIRS',
    description: 'Responsible for tax collection and revenue generation.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 9,
  },
  {
    id: '7',
    name: 'Ministry of Agriculture',
    acronym: 'MOA',
    description: 'Promotes agricultural development and food security.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 5,
  },
  {
    id: '8',
    name: 'Ministry of Environment',
    acronym: 'MOE',
    description: 'Focuses on environmental protection and sustainability.',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png',
    serviceCount: 6,
  },
]
